import { AfterViewChecked, ChangeDetectorRef, Component } from '@angular/core';
import { SpinnerService } from '../../services/spinner.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-spinner',
  standalone: false,
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent implements AfterViewChecked {

  isLoading: Observable<boolean>;
  constructor(private spinnerService: SpinnerService, private cdr: ChangeDetectorRef) {
    this.isLoading = this.spinnerService.isLoading;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

}